var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasstationfleet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6128_9118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6042 34.8984H3.89404V36.0004H34.6042V34.8984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6287 8.30223V5.14309H24.8694V7.23693H25.9715V4.04102H12.5266V8.30223H10.8735V9.40431H27.5511V8.30223H13.6287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6287 14.9878V11.8286H24.8694V13.9225H25.9715V10.7266H12.5266V14.9878H10.8735V16.0899H27.5511V14.9878H13.6287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0123 31.6653V0H8.48582V20.5714H4.81234V7.2H6.35521V11.0204H5.51026V12.1224H7.45721V6.09799H4.81234V4.44495C4.81234 2.5612 3.27974 1.0286 1.396 1.0286V2.13061C2.6721 2.13061 3.71026 3.16877 3.71026 4.44487V4.48158H1.50618V10.5061H3.71026V21.6734H8.48575V29.7918H9.58775V1.10201H28.9102V31.6653H6.0613V33.8326H7.16331V32.7673H31.3347V33.8326H32.4367V31.6653H30.0123ZM3.71026 9.40409H2.60825V5.58366H3.71026V9.40409Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6128_9118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasstationfleet);
export default __webpack_public_path__ + "static/media/gasstationfleet.f6b694ba516c390706fed976a32f4bd8.svg";
export { ForwardRef as ReactComponent };